import api from '@pray/shared/utils/api';

export async function regenerateTranscription({ artistId, contentId }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');

  const url = `/web/studio/artists/${artistId}/content/${contentId}/transcription`;
  const response = await api.executePostRequest(url);

  return response.data;
}
